import React from 'react';
import ReactDOM from 'react-dom';

import './styles/index.css';

import CrewApp from './CrewApp';

ReactDOM.render(<CrewApp />, document.getElementById('root'));
